export const useSkinAgeAndFocusArea = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const skinAge = urlParams.get('skin_age');
  const focusAreas = urlParams.get('your_focus_area')?.split(',');

  return { skinAge, focusAreas };
};
